import React from 'react';
import Carousel from 'react-multi-carousel';
import { useRecoilValue } from 'recoil';
import { SvgIcon } from '~/common/components/ui-elements';
import { OfferMediaContent } from '../../store';
import styles from './index.module.scss';

export const OfferBanner = () => {
  const [deviceType, setDeviceType] = React.useState<string>('desktop');
  const carouselRef = React.useRef<Carousel>(null);
  const offerMedia = useRecoilValue(OfferMediaContent);

  React.useEffect(() => {
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width < 464) {
        setDeviceType('mobile');
      } else if (width >= 464 && width < 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };

    updateDeviceType();
    window.addEventListener('resize', updateDeviceType);
    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  const filteredMedia = offerMedia.filter(
    (m) => m.devices.includes(deviceType) && !m.isThumbnail
  );

  return (
    <div className={styles.offerBannerContainer}>
      <Carousel
        ref={carouselRef}
        arrows
        swipeable
        centerMode={false}
        customLeftArrow={<CustomLeftArrow />}
        customRightArrow={<CustomRightArrow />}
        containerClass={styles.carouselContainer}
        responsive={{
          desktop: {
            breakpoint: { max: 4000, min: 1024 },
            items: 1,
            slidesToSlide: 1,
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1,
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1,
          },
        }}
      >
        {filteredMedia.map((m, index) => (
          <div key={index} className={styles.offerImageWrapper}>
            <img
              src={m.url}
              alt={m.url}
              className={styles.offerImage}
              loading="lazy"
            />
            {!!m.disclaimer && (
              <div
                className={styles.imageDisclaimer}
                dangerouslySetInnerHTML={{ __html: m.disclaimer }}
                style={{ color: m.disclaimerColor ?? '#FFFFFF' }}
              />
            )}
          </div>
        ))}
      </Carousel>
    </div>
  );
};

interface ArrowsProps {
  onClick?: () => void;
}
const CustomLeftArrow = ({ onClick }: ArrowsProps) => {
  return (
    <SvgIcon
      className={styles.customLeftArrow}
      type="chevronLeft"
      size={2}
      onClick={onClick}
    />
  );
};

const CustomRightArrow = ({ onClick }: ArrowsProps) => {
  return (
    <SvgIcon
      className={styles.customRightArrow}
      type="chevronRight"
      size={2}
      onClick={onClick}
    />
  );
};
